/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

//LDS Customer Order History refers to Users Order History

import { Module, Node, Waiting } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

// import { IGroup, IGroupDelivery, IGroups } from '../../common/get-groups';
// import { IOrderInformation } from '../../common/get-order-information';
import { IGroup, IGroupDelivery, IGroups, IOrderInformation, ISalesLine } from '@msdyn365-commerce-modules/order-management';
import { ISalesOrder } from './components/get-sales-order';
import { IHeader, IList, IOrderHistoryViewProps } from './lds-customer-order-history';
//@ts-ignore
import { Primary } from '@churchofjesuschrist/eden-buttons';

interface GroupDeliveryProps extends IGroupDelivery {
    salesLines?: any;
    resources?: any;
}
interface ListProps extends IList {
    resources?: any;
}
interface SalesProps extends ISalesOrder {
    resources?: any;
}
interface GroupProps extends IGroup {
    resources?: any;
}
interface GroupsProps extends IGroups {
    resources?: any;
}

export const OrderHistoryOrderInfomation: React.FC<IOrderInformation> = ({
    orderInformationProps,
    salesId,
    receiptId,
    channelName,
    createdDate,
    count,
    amount,
    channelReferenceId
}) => {
    return (
        <Node {...orderInformationProps}>
            {channelName}
            {salesId}
            {receiptId}
            {createdDate}
            {count}
            {amount}
            {/* {channelReferenceId} */}
        </Node>
    );
};

export const OrderHistoryGroupDelivery: React.FC<GroupDeliveryProps> = ({
    deliveryProps,
    heading,
    count,
    processing,
    address,
    trackingInfo,
    salesLines,
    resources
}) => {
    //@ts-ignore
    if (address && address.props) {
        if (salesLines.length === 0) {
            //@ts-ignore
            address.props.resource.shipToLabel = resources.delivereySalesLines;
        }
    }
    return (
        <Node {...deliveryProps}>
            {/* {salesLines && salesLines.length !== 0 && heading} */}
            {/* {salesLines && salesLines.length === 0 && <div className='ms-order-history__sales-status'>{resources.deliveredSalesLines}</div>} */}
            {/* {count} */}
            {/* {processing} */}
            {/* {address} */}
            {/* {trackingInfo} */}
        </Node>
    );
};

export const OrderHistoryGroup: React.FC<GroupProps> = ({ groupProps, delivery, salesLinesProps, salesLines, resources }) => {
    let deliveryLines;
    if (salesLines && salesLines[0]) {
        deliveryLines = salesLines.filter(saleLine => {
            if (saleLine.data.product) {
                //@ts-ignore
                return saleLine.data.product.ExtensionProperties[0].Value?.BooleanValue === false;
            } else {
                return;
            }
        });
    }
    return (
        <Node {...groupProps}>
            {delivery && <OrderHistoryGroupDelivery {...delivery} salesLines={deliveryLines} resources={resources} />}
            {salesLines && (
                <Node {...salesLinesProps}>
                    {salesLines.map((salesLine: ISalesLine) => (
                        <React.Fragment key={salesLine.data.salesLine.LineId}>{salesLine.salesLine}</React.Fragment>
                    ))}
                </Node>
            )}
        </Node>
    );
};

export const OrderHistoryGroups: React.FC<GroupsProps> = ({ groupsProps, groups, resources }) => (
    <Node {...groupsProps}>
        {groups.map((group: IGroup, index: number) => (
            <OrderHistoryGroup key={index} {...group} resources={resources} />
        ))}
    </Node>
);

export const OrderHistoryHeader: React.FC<IHeader> = ({ headerProps, heading, orderCountLabel, extraActions }) => {
    return (
        <Node {...headerProps}>
            {heading}
            {/* {orderCountLabel} */}
            {extraActions}
        </Node>
    );
};

export const OrderHistorySalesOder: React.FC<SalesProps> = ({
    salesOrderProps,
    orderInfomation,
    groups,
    orderDetailsLink,
    expandProductsButton,
    resources
}) => (
    <Node {...salesOrderProps}>
        {orderInfomation && <OrderHistoryOrderInfomation {...orderInfomation} />}
        {groups && <OrderHistoryGroups {...groups} resources={resources} />}
        {expandProductsButton}
        {orderDetailsLink}
    </Node>
);

export const OrderHistoryList: React.FC<ListProps> = ({ listProps, salesOrders, resources }) => (
    <Node {...listProps}>
        {salesOrders &&
            salesOrders.map((salesOrder: ISalesOrder, index: number) => (
                <OrderHistorySalesOder key={index} {...salesOrder} resources={resources} />
            ))}
    </Node>
);

export const OrderHistoryView: React.FC<IOrderHistoryViewProps> = ({
    orderHistoryProps,
    header,
    alert,
    // loading,
    emptyMessage,
    backToShoppingLink,
    list,
    table,
    moreButton,
    resources,
    getOrderHistory
}) => {
    const [shouldShowMore, setShouldShowMore] = React.useState(true);
    const [skip, setSkip] = React.useState(5);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        sessionStorage.setItem('orderHistory', 'true');
    }, []);

    const handleClick = async () => {
        setLoading(true);
        const res = await getOrderHistory(skip, setShouldShowMore);
        // if (!props.viewState.connectionFailed) {
        setSkip(prevState => (prevState += 5));
        // }

        setLoading(false);

        return res;
    };

    return (
        <Module {...orderHistoryProps} style={{ width: '100%', height: '100%', borderTop: '1px solid #000' }}>
            {/* {header && <OrderHistoryHeader {...header} />} */}
            {/* {loading} */}
            {loading && (
                <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '10px' }}>
                    <Waiting />
                </div>
            )}
            {alert && (
                <>
                    {alert}
                    {/* {backToShoppingLink} */}
                </>
            )}
            {emptyMessage && (
                <>
                    {emptyMessage}
                    {/* {backToShoppingLink} */}
                </>
            )}
            {list && <OrderHistoryList {...list} resources={resources} />}
            {table}
            {shouldShowMore && !emptyMessage && (
                <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '10px' }}>
                    <Primary style={{ width: '100%' }} onClick={() => handleClick()}>
                        {resources.moreButtonText}
                    </Primary>
                </div>
            )}
            {/* {moreButton && moreButton} */}
        </Module>
    );
};

export default OrderHistoryView;
